
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Styles from './styles/ScheduleResume.module.css'
import { WEEK_DAYS } from '../utils/dates';

export default function ScheduleResume(props) {
    return (
        <div className={Styles.container}>
            <Stack
                direction='row'
                justifyContent='center'
                alignItems='flex-start'
                flexWrap='wrap'
                spacing={1}
                sx={{ m: 1 }}
            >

                {!props.schedule ? null :
                    props.schedule.map((day, index) => {
                        return (
                            <Stack
                                justifyContent='center'
                                alignItems='center'
                                className={day.active ? Styles.activeDay : Styles.inactiveDay}
                                key={index}
                            >
                                <span> {WEEK_DAYS[index].slice(0, 1)}</span>
                                {!day.active ? null :
                                    day.openAllDay ?
                                        <>
                                            <Divider sx={{ width: '100%' }} />
                                            <span>Todo <br />el dia</span>
                                        </> :
                                        day.time.map((time, i) => {
                                            return (
                                                <Stack key={i}>
                                                    <Divider sx={{ width: '100%' }} />
                                                    <span>{time.start.slice(0, 2) + ':' + time.start.slice(2,)}</span>
                                                    <span>{time.end.slice(0, 2) + ':' + time.end.slice(2,)}</span>
                                                </Stack>
                                            )
                                        })
                                }
                            </Stack>
                        )
                    })
                }
            </Stack>
        </div >
    )
}